// its middlewear to handle reducer call to update a state

import { getData } from "../../../backend/api";

const fetchTrackStatus = (pass) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_TRACK_LOADING",
    });
    getData({pass}, `whistleblowing/trackStatus`)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "FETCH_TRACK_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_TRACK_ERROR",
            payload: "validationFailed",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_TRACK_ERROR",
          payload: "validationFailed",
        });
      });
  };
};

const clearTrackStatus = () => {
    return (dispatch) => {
      dispatch({
        type: "CLEAR_TRACK_STATUS",
      });
    };
  };

export { fetchTrackStatus,clearTrackStatus };
